<template>
    <v-dialog
      v-model="dialog"
      persistent
      width="600"
      @keydown.esc="close"
      >
      <v-card v-if="selectedDate">
         
        <v-toolbar card color="primary subheading" dark height="64">
            <v-layout row align-start justify-right>
                <v-flex grow align-self-center>
                    <span class="title">{{weekDescription}} {{yearDescription}} <span v-if="!isWeekMode">{{moment(selectedDate).format("dddd DD/MM/YYYY")}}</span></span>
                </v-flex>
            </v-layout>
        </v-toolbar>
            <v-layout mt-2 column wrap align-center justfy-center>
                <v-flex shrink mb-2 mt-2>
                     <span class="title">Bulk Adjust By</span>
                </v-flex>
                <v-flex shrink mb-4>
                    <v-radio-group 
                        hide-details
                        v-model="selectedAdjustBy">
                        <v-layout row>
                            <v-flex xs-4>
                                <v-radio :label="uomDescription" :value="adjustBy.uom"></v-radio>
                            </v-flex>
                            <v-flex xs-4>
                                <v-radio label="%" :value="adjustBy.percent"></v-radio>
                            </v-flex>
                            <v-flex xs-4>
                                <v-radio :label="uomHectareDescription" :value="adjustBy.uomPerHectare"></v-radio>
                            </v-flex>
                        </v-layout>
                    </v-radio-group>
                </v-flex>
                <v-flex shrink mb-2>
                    <v-layout row>
                        <v-flex shrink>
                            <v-btn fab small @click="decrement">
                                <v-icon>remove</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex grow>
                            <v-text-field
                                v-if="!manualEditMode"
                                style="width: 250px;"
                                class="forecastBulkInput"
                                :value="adjustByValue"
                                readonly
                                single-line
                                hide-details
                                outline
                                @click="manualEditMode = true">
                            </v-text-field>
                            <EditTableCell
                                v-else
                                style="width: 250px;"
                                class="forecastBulkInput"
                                :value="`${adjustByValue}`"
                                @close="manualEditMode = false"
                                @input="handleAdjustByValueChanged">
                            </EditTableCell>
                        </v-flex>
                        <v-flex shrink>
                            <v-btn fab small @click="increment">
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
             <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn @click="openConfirmDialog" :loading="loading" color="primary">Save</v-btn>
                    <v-btn @click="close" :disabled="loading" color="error">Cancel</v-btn>
                </v-card-actions>
      </v-card>
    <ConfirmDialog :DisplayDialog="confirmDialog" :DialogTitle="'Confirmation'" :DialogContents="'Please confirm you want to perform the bulk adjust.'" @Yes="save" @No="confirmDialog = false"/>

    </v-dialog>
</template>

<script>

import ForecastingUtilService from '@/services/forecastingUtilService'
import ConfirmDialog from '@/components/generic/YesNoPopup.vue';
import EditTableCell from '@/components/forecasting/EditTableCell.vue';
import ForecastingDistributionService from '@/services/forecastingDistributionService';
import * as Constants from '@/helpers/constants';

import { mapState, mapActions, mapGetters } from "vuex";

import moment from 'moment'
export default {
    components: {
        ConfirmDialog,
        EditTableCell
    },
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        selectedDate: {
            type: String,
            required: true
        },
        rules: {
            type: Array,
            required: false,
            default() {
                return []
            }
        },
        isWeekMode: {
            type: Boolean,
            required: true,
            default: true
        },
        originalGrandTotal: {
            type: Number,
            required: true
        },
        originalTotalSquareMeters: {
            type: Number,
            required: true
        }
    },
    data(){
        let adjustBy = {
            uom: 0,
            percent: 1,
            uomPerHectare: 2
        }

        return {
            moment,
            loading: false,
            confirmDialog: false,
            selectedAdjustBy: adjustBy.uom,
            adjustBy: adjustBy,
            manualEditMode: false,
            initialAdjustByUOMValue: 100,
            initialAdjustByPercentValue: 1,
            initialAdjustByHectareValue: 1,
            adjustByUOMValue: 100,
            adjustByPercentValue: 1,
            adjustByUOMPerHectareValue: 1
        };
    },
    computed: {
        ...mapState("ForecastingStore", [
            "calendarSortedItems",
            "financialYearCalendarData",
            "selectedUOM"
        ]),
        ...mapGetters("ForecastingStore", [            
            "uomScaleFactor"
        ]),
        weekDescription(){
            return "WK"+ForecastingUtilService.getFinancialWeek(this.selectedDate, this.financialYearCalendarData);
        },
        yearDescription(){
            return moment(this.selectedDate).format('[FY]YYYY');
        },
        adjustByValue(){
            if(this.selectedAdjustBy == this.adjustBy.uom){
                return this.adjustByUOMValue;
            }

            if(this.selectedAdjustBy == this.adjustBy.percent){
                return this.adjustByPercentValue;
            }

            if(this.selectedAdjustBy == this.adjustBy.uomPerHectare){
                return this.adjustByUOMPerHectareValue;
            }

            return 0;
        },
        suffix(){
            if(this.selectedAdjustBy == this.adjustBy.uom){
                return "KG";
            }

            if(this.selectedAdjustBy == this.adjustBy.percent){
                return "%";
            }

            if(this.selectedAdjustBy == this.adjustBy.uomPerHectare){
                return "KG per Hectare";
            }

            return "";
        },
        incrementDecrementAmount(){
            if(this.selectedAdjustBy == this.adjustBy.uom){
                return 100;
            }

            if(this.selectedAdjustBy == this.adjustBy.percent){
                return 1;
            }

            if(this.selectedAdjustBy == this.adjustBy.uomPerHectare){
                return 1;
            }

            return 1;
        },
        newTotalValue(){
            if(this.selectedAdjustBy == this.adjustBy.uom){
                return this.originalGrandTotal + this.adjustByUOMValue;
            }

            if(this.selectedAdjustBy == this.adjustBy.percent){
                return this.originalGrandTotal + Math.round(this.originalGrandTotal * (this.adjustByPercentValue / 100));
            }

            if(this.selectedAdjustBy == this.adjustBy.uomPerHectare){
                return this.originalGrandTotal + Math.round((this.originalTotalSquareMeters / 10000) * this.adjustByUOMPerHectareValue);
            }

            return this.originalGrandTotal;
        },
        adjustedValueInUOM() {
            if(this.selectedAdjustBy == this.adjustBy.uom){
                return  this.adjustByUOMValue;
            }

            if(this.selectedAdjustBy == this.adjustBy.percent){
                return  Math.round(this.originalGrandTotal * (this.adjustByPercentValue / 100));
            }

            if(this.selectedAdjustBy == this.adjustBy.uomPerHectare){
                return Math.round((this.originalTotalSquareMeters / 10000) * this.adjustByUOMPerHectareValue);
            }

            return 0;
        },
        isFutureWeek() {
            return moment(this.selectedDate) > moment().endOf('week');
        },
        uomDescription() {
            if(this.selectedUOM === Constants.HARVESTPLAN_UOM_ENUM.KG.ID) {
                return "KGs"
            }

            if(this.selectedUOM === Constants.HARVESTPLAN_UOM_ENUM.TRAYSPUNNETS.ID) {
                return "Trays"
            }

            return "";
        },
        uomHectareDescription() {
            if(this.selectedUOM === Constants.HARVESTPLAN_UOM_ENUM.KG.ID) {
                return "KGs Per Hectare"
            }

            if(this.selectedUOM === Constants.HARVESTPLAN_UOM_ENUM.TRAYSPUNNETS.ID) {
                return "Trays Per Hectare"
            }

            return "";
        }
    },
    methods: {
        ...mapActions("ForecastingStore", [
            "handleForecastsChanged",
            "updateData"
        ]),
        handleAdjustByValueChanged(event){
            var newValue = event.value;
            this.manualEditMode = false;

            newValue = parseInt(newValue);
            if(!isNaN(newValue)){
                this.setAdjustByValue(newValue);
            }
        },
        setAdjustByValue(newValue){
            if(this.selectedAdjustBy == this.adjustBy.uom){
                this.adjustByUOMValue = newValue;
            }

            if(this.selectedAdjustBy == this.adjustBy.percent){
                this.adjustByPercentValue = newValue;
            }

            if(this.selectedAdjustBy == this.adjustBy.uomPerHectare){
                this.adjustByUOMPerHectareValue = newValue;
            }
        },
        resetAdjustByValues(){
            this.adjustByUOMValue = this.initialAdjustByUOMValue;
            this.adjustByPercentValue = this.initialAdjustByPercentValue;
            this.adjustByUOMPerHectareValue = this.initialAdjustByHectareValue;
        },
        close() {
            this.resetAdjustByValues();
            this.loading = false;
            this.$emit("close");
        },
        async save() {
            this.confirmDialog = false;
            this.loading = true;
            await this.modifyForecastValues(this.newTotalValue);
            this.close();
        },
        openConfirmDialog() {
            this.confirmDialog = true;
        },
        increment() {
            this.$nextTick(() => {
                this.setAdjustByValue(this.adjustByValue + this.incrementDecrementAmount);
            });
        },
        decrement() {
            this.$nextTick(() => {
                this.setAdjustByValue(this.adjustByValue- this.incrementDecrementAmount);
            });
        },
        async modifyForecastValues(newTotal){
            await this.handleForecastsChanged({
                forecasts: this.getBulkUpdateForecasts(newTotal)
            });

            await this.updateData();
        },
        getBulkUpdateForecasts(newTotal){
            if(this.isWeekMode){
                return this.getWeekUpdates(newTotal);
            } else {
                return this.getDayUpdates(newTotal);
            }
        },
        distributeValues(oldTotal, newTotal, currentValues){
            // Prevent negative numbers
            if(newTotal < 0){
                newTotal = 0;
            }

            var shouldEvenly = currentValues.filter(v=> v > 0).length == 0;
            let newValues = currentValues.map(x => {
                if (shouldEvenly){
                    // Distribute evenly
                    return Math.round(newTotal / currentValues.length);
                } else if(x) {
                    // If this has a value, measure portion using that
                    return Math.round(newTotal * (
                        parseInt(x) / oldTotal
                    ));
                } else {
                    return 0;
                }
            });
            // Distribute the remainder
            let totalRemaining = newTotal - newValues.reduce((a, v) => a + v, 0);
            let i = 0;
            let loopsWithoutDoingAnything = 0;
            while(totalRemaining > 0 && newValues.length > 0){
                if(newValues[i] != 0 || shouldEvenly){
                    newValues[i] += 1;
                    totalRemaining--;
                } else {
                    loopsWithoutDoingAnything++;
                    if(loopsWithoutDoingAnything == newValues.length){
                        break;
                    }
                }

                i = (i + 1) % newValues.length;
            }
            i = newValues.length - 1;
            loopsWithoutDoingAnything = 0;
            while(totalRemaining < 0 && newValues.length > 0){
                if(newValues[i] > 0) {
                    newValues[i] -= 1;
                    totalRemaining++;
                } else {
                    loopsWithoutDoingAnything++;
                    if(loopsWithoutDoingAnything == newValues.length){
                        break;
                    }
                }

                i--;
                if(i < 0){
                    i = newValues.length - 1;
                }
            }

            return newValues;
        },
        distributeWeekValues(remainderAllTotal, weeks, increase) {
            let newValues = weeks.map(x => {
                if (x.remainderTotal) {
                    // If this has a value, measure portion using that
                    return Math.round(increase * (
                        parseInt(x.remainderTotal) / remainderAllTotal
                    ) + x.total);
                } else {
                    return 0;
                }
            });
            return newValues;
        },
        getWeekUpdates(newTotal){
            let includedWeeks = [];

            // Go through all of the calendar items
            for(let i = 0; i < this.calendarSortedItems.length; i++){
                let item = this.calendarSortedItems[i];

                // Go through all of the weeks for this item
                for(let j = 0; j < item.forecastWeeks.length; j++){
                    let forecastWeek = item.forecastWeeks[j];
                    var remainderActiveRowTotal = 0;
                    
                    if(forecastWeek.week == this.selectedDate) {
                        remainderActiveRowTotal = forecastWeek.forecastDays
                        .filter(fd=> !fd.adjustedValueLocked)
                        .reduce((t,v)=> t += (v.adjustedValue !== "" ? v.adjustedValue : (v.forecastValue !== "" ? v.forecastValue : 0)), 0);
                    }
                    // Check if this is a week to modify
                    if(forecastWeek.week == this.selectedDate && !forecastWeek.locked && (remainderActiveRowTotal > 0 || this.selectedAdjustBy != this.adjustBy.uom || this.isFutureWeek)){
                        forecastWeek.remainderTotal = remainderActiveRowTotal;
                        includedWeeks.push({
                            forecastWeek,
                            cropLocationId: item.cropLocationId,
                            varietyId: item.varietyId
                        });
                    }
                }
            }
            let newDistributedTotals = []
            // If Allocating Bulk Update by KGs in current week, ignore 0kgs row 
            if(this.selectedAdjustBy == this.adjustBy.uom && !this.isFutureWeek){
                newDistributedTotals = this.distributeWeekValues(
                includedWeeks.reduce((t,v)=> t += v.forecastWeek.remainderTotal, 0),
                includedWeeks.map(x => x.forecastWeek),
                this.adjustedValueInUOM
                ) 
            }
             else {
                newDistributedTotals = this.distributeValues(
                this.originalGrandTotal,
                newTotal,
                includedWeeks.map(x => x.forecastWeek.total)
                );
            }
            
            return includedWeeks.map(
                (x, i) => this.getWeekValueModified(
                        x.forecastWeek, 
                        newDistributedTotals[i],
                        x.cropLocationId, 
                        x.varietyId
                    )
            // Flatten the array of arrays
            ).reduce((a, v) => { 
                a.push(...v); 
                return a; 
            }, []);
        },
        getDayUpdates(newTotal){
            let includedDays = [];

            // Go through all of the calendar items
            for(let i = 0; i < this.calendarSortedItems.length; i++){
                let item = this.calendarSortedItems[i];

                // Go through all of the weeks for this item
                for(let j = 0; j < item.forecastWeeks.length; j++){
                    let forecastWeek = item.forecastWeeks[j];

                    // Go through all of the days for this week
                    for(let k = 0; k < forecastWeek.forecastDays.length; k++){
                        let forecastDay = forecastWeek.forecastDays[k];

                        // Check if this is a day to modify
                        if(forecastDay.day == this.selectedDate && (!forecastDay.forecastValueLocked || !forecastDay.adjustedValueLocked)){
                            includedDays.push({
                                forecastDay,
                                cropLocationId: item.cropLocationId,
                                varietyId: item.varietyId
                            });
                        }
                    }
                }
            }

            let newDistributedTotals = this.distributeValues(
                this.originalGrandTotal,
                newTotal,
                includedDays.map(x => {
                    var total = 0;
                    if(x.forecastDay.actualValue != ""){
                        total = parseInt(x.forecastDay.actualValue);
                    } else if(x.forecastDay.adjustedValue !== "" && x.forecastDay.forecastValueLocked){
                        total = parseInt(x.forecastDay.adjustedValue);
                    } else if(x.forecastDay.forecastValue !== ""){
                        total = parseInt(x.forecastDay.forecastValue);
                    }
                    return total;
                })
            );

            return includedDays.map(
                (x, i) => this.getDayValueModified(
                        x.forecastDay, 
                        newDistributedTotals[i],
                        x.cropLocationId, 
                        x.varietyId
                    )
            // Flatten the array of arrays
            ).reduce((a, v) => { 
                a.push(...v); 
                return a; 
            }, []);
        },
        getWeekValueModified(forecastWeek, newTotal, cropLocationId, varietyId){
            var bulkUpdateForecasts = [];

            let dayValues = ForecastingDistributionService.getNewDayValuesForForecastWeek(
                newTotal, 
                forecastWeek.forecastDays,
                forecastWeek.week
            );

            for(let i = 0; i < dayValues.length; i++){
                var modifiedForecast = this.modifyForecastValue(
                    dayValues[i].day, 
                    dayValues[i].newValue, 
                    forecastWeek.forecastDays, 
                    cropLocationId, 
                    varietyId,
                    false
                );
                if(modifiedForecast != null){
                    bulkUpdateForecasts.push(modifiedForecast);
                }
            }

            return bulkUpdateForecasts;
        },
        getDayValueModified(forecastDay, newTotal, cropLocationId, varietyId){
            console.log("getDayValueModified");
            var bulkUpdateForecasts = [];

            let dayValues = ForecastingDistributionService.getNewDayValuesForForecastWeek(
                newTotal, 
                [forecastDay],
                forecastDay.day
            );

            for(let i = 0; i < dayValues.length; i++){
                var modifiedForecast = this.modifyForecastValue(
                    dayValues[i].day, 
                    dayValues[i].newValue, 
                    [forecastDay], 
                    cropLocationId, 
                    varietyId,
                    false
                );
                if(modifiedForecast != null){
                    bulkUpdateForecasts.push(modifiedForecast);
                }
            }

            return bulkUpdateForecasts;
        },
        modifyForecastValue(day, newValue, forecastDays, cropLocationId, varietyId, allowZeroes){
            let forecastDay = forecastDays.find(x => x.day == day);

            // Start without any changes
            let newForecastValue = forecastDay.forecastValue;
            let newAdjustedValue = forecastDay.adjustedValue;

            if(!forecastDay.forecastValueLocked){
                // Update the forecast value
                newForecastValue = newValue;

                // If the forecast value was blank and it is now being set to 0
                // Leave it as blank
                if(newForecastValue === 0 && forecastDay.forecastValue === "" && !allowZeroes){
                    newForecastValue = "";
                }
            } else if(!forecastDay.adjustedValueLocked){
                // Update the adjusted value
                newAdjustedValue = newValue;

                // If the adjusted value was blank and it is now being set to 0
                // Leave it as blank
                if(newAdjustedValue === 0 && forecastDay.adjustedValue === "" && !allowZeroes){
                    newAdjustedValue = "";
                }
            }

            // If the values haven't changed, no need to send a modification
            if(newForecastValue === forecastDay.forecastValue 
            && newAdjustedValue === forecastDay.adjustedValue){
                return null;
            }

            // Return a modification
            return {
                forecastDate: day,
                forecastValue: newForecastValue === "" ? null : newForecastValue,
                adjustedValue: newAdjustedValue === "" ? null : newAdjustedValue,
                cropLocationId: cropLocationId,
                varietyId: varietyId
            };
        }
    },
    async created(){
    },
    mounted() {
        this.$root.$on('bulkUpdateComplete', this.close);
    }
}
</script>

<style>

.forecastBulkInput input {
    text-align: center;
    font-size: 20px;
}
</style>